import { render, staticRenderFns } from "./ContactsTable.vue?vue&type=template&id=3814bdfb&scoped=true"
import script from "./ContactsTable.vue?vue&type=script&lang=js"
export * from "./ContactsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3814bdfb",
  null
  
)

export default component.exports